import type { Variants } from 'framer-motion';

const GUIDED_STEP_SLIDE_DURATION_IN = 0.35;
const GUIDED_STEP_SLIDE_DURATION_OUT = 0.2;
const GUIDED_STEP_SLIDE_EDGE_SCALE = 0.6;
const GUIDED_STEP_SLIDE_EDGE_SKEW_X_DEG = 30;
const GUIDED_STEP_SLIDE_EXIT_EASE = [0.4, 0, 1, 1] as const;
const GUIDED_STEP_SLIDE_ENTER_EASE = [0.4, 0, 0.2, 1] as const;

/**
 * Slides: forward = exit left, enter from right; backward = mirror.
 * `custom` on the motion child must be `1` (next) or `-1` (back).
 * Enter uses Material fast-out–slow-in; exit uses Material acceleration. Scale and `skewX`
 * use edge values off-screen (`GUIDED_STEP_SLIDE_EDGE_*`) and reset at rest.
 */
export const guidedStepCardSlideVariants: Variants = {
  initial: (direction: number) => ({
    x: direction > 0 ? '100%' : '-100%',
    scale: GUIDED_STEP_SLIDE_EDGE_SCALE,
    skewX: -direction * GUIDED_STEP_SLIDE_EDGE_SKEW_X_DEG,
  }),
  animate: {
    x: 0,
    scale: 1,
    skewX: 0,
    transition: {
      duration: GUIDED_STEP_SLIDE_DURATION_IN,
      ease: GUIDED_STEP_SLIDE_ENTER_EASE,
    },
  },
  exit: (direction: number) => ({
    x: direction > 0 ? '-100%' : '100%',
    scale: GUIDED_STEP_SLIDE_EDGE_SCALE,
    skewX: -direction * GUIDED_STEP_SLIDE_EDGE_SKEW_X_DEG,
    transition: {
      duration: GUIDED_STEP_SLIDE_DURATION_OUT,
      ease: GUIDED_STEP_SLIDE_EXIT_EASE,
    },
  }),
};
